<template>
  <div class="project-new">
    <Row :gutter="16">
      <i-col span="12">
        <Form ref="newForm" :model="projectModel"
          :rules="modelValidate"
          label-position="left"
          :label-width="120">
          <FormItem label="名称" prop="name">
            <Input v-model="projectModel.name" placeholder="输入名称" />
          </FormItem>
          <FormItem label="项目立项备案号" prop="filingNo">
            <Input v-model="projectModel.filingNo" placeholder="输入项目立项备案号" />
          </FormItem>
          <FormItem label="规划许可证号" prop="planLicenseNo">
            <Input v-model="projectModel.planLicenseNo" placeholder="输入规划许可证号" />
          </FormItem>
          <FormItem label="施工许可证号" prop="constrLicenceNo">
            <Input v-model="projectModel.constrLicenceNo" placeholder="输入施工许可证号" />
          </FormItem>
          <FormItem label="土地使用证编号" prop="landLicenceNo">
            <Input v-model="projectModel.landLicenceNo" placeholder="输入土地使用证编号" />
          </FormItem>
          <FormItem label="类型" prop="type">
            <Cascader :data="prjTypeSelect" change-on-select v-if="prjTypeSelect&&prjTypeSelect.length"  @on-change="prjTypeSelected" placeholder="选择"></Cascader>
            <!-- <Select v-model="projectModel.type" filterable>
              <Option v-for="(tp,idx) in $common.getEnumSelect($common.companyType)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
            </Select> -->
          </FormItem>
          <FormItem label="项目所在地" prop="cityId">
            <!-- <Input v-model="industryModel.cityId" placeholder="输入城市" /> -->
            <Cascader :data="cities" :load-data="loadCityData" @on-change="citySelected" placeholder="选择"></Cascader>
          </FormItem>
          <FormItem label="工程造价(元)" prop="cost">
            <InputNumber :min="0" :step="10000"
              style="width: 150px;display:inline-block"
              v-model="projectModel.cost"
              placeholder="输入工程造价(元)"></InputNumber>
            <Divider type="vertical" v-if="projectModel.cost" />
            <h3 style="display:inline-block" v-if="projectModel.cost"> {{`¥ ${projectModel.cost}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3>
            <Divider type="vertical" v-if="projectModel.cost" />
            <h3 style="display:inline-block">{{$common.transformNumberIntoCHS(projectModel.cost)}}</h3>
          </FormItem>
          <FormItem label="建设规模" prop="area">
            <InputNumber :min="0" :step="10000" style="width: 200px" v-model="projectModel.area" placeholder="输入建设规模(m/m²/m³)"></InputNumber>
          </FormItem>
          <FormItem label="开竣工工日期" prop="startdate">
            <DatePicker v-model="projectModel.daterange"
              @on-change="prjDateChange"
              type="daterange"
              placement="bottom-end"
              format="yyyy/MM/dd"
              placeholder="选择开竣工日期"
              style="width: 100%"></DatePicker>
          </FormItem>
          <FormItem label="工期(天)" prop="duration">
            <Input v-model="projectModel.duration" placeholder="工期天数" />
          </FormItem>
          <FormItem label="质量要求" prop="qualityRequirement">
            <Input v-model="projectModel.qualityRequirement" placeholder="质量要求" />
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'project-new',
  props: {
  },
  data () {
    return {
      loading: false,
      projectModel: {
        name: null,
        type: null,
        filingNo: null,
        planLicenseNo: null,
        constrLicenceNo: null,
        landLicenceNo: null,
        cityCode: null,
        cityId: null,
        area: null,
        cost: null,
        site: null,
        startdate: null,
        finishdate: null,
        duration: null,
        qualityRequirement: null
      },
      modelValidate: {
        name: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        cityId: [
          { required: true, type: 'number', message: '请选择项目所在地', trigger: 'blur' }
        ],
        cost: [
          { required: true, type: 'number', message: '请填写造价', trigger: 'blur' }
        ],
        startDate: [
          { required: true, message: '请填写开工日期', trigger: 'blur' }
        ],
        planLicenseNo: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        constrLicenceNo: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        type: [
          { required: true, type: 'number', message: '请选择', trigger: 'blur' }
        ]
      },
      cities: [],
      prjTypes: [],
      prjTypeSelect: null
    }
  },
  watch: {
  },
  mounted () {
    this.initCitySelect()
    this.initPrjTypes().then((list) => {
      this.prjTypeSelect = this.prepPrjTypeCascader(list)
    })
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    prjDateChange (date) {
      console.log(date)
      if (date && date instanceof Array && date.length === 2) {
        this.projectModel.startdate = require('moment')(date[0]).format('YYYY-MM-DD')
        this.projectModel.finishdate = require('moment')(date[1]).format('YYYY-MM-DD')
        this.projectModel.duration = require('moment')(date[1]).diff(require('moment')(date[0]), 'days')
      }
    },
    initCitySelect () {
      Api.City.listCities({
        tier: 1,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          return {
            id: c.tid,
            value: c.tid,
            label: c.name,
            tier: c.tier,
            parent: c.parent,
            loading: false,
            children: []
          }
        })
        this.cities = data
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
      })
    },
    loadCityData (item, callback) {
      item.loading = true
      let parentId = item.value
      let tier = item.tier || 0
      let curNode = null
      if (tier === 1) {
        curNode = this.cities.filter((c) => {
          return c.id === item.id
        })[0]
      } else {
        let parentNode = this.cities.filter((c) => {
          return c.id === item.parent
        })
        curNode = parentNode[0]
      }
      console.log(curNode)
      Api.City.listCities({
        tier: tier + 1,
        parentId: parentId,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          if (tier === 1) {
            return {
              id: c.tid,
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent,
              loading: false,
              children: []
            }
          } else {
            return {
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent
            }
          }
        })
        let retData = [{
          value: parentId,
          label: '本级'
        }]
        data.forEach((d) => {
          retData.push(d)
        })
        if (tier === 0) {
          curNode = retData
        } else {
          item.children = retData
        }
        item.loading = false
        callback()
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
        item.loading = false
        callback()
      })
    },
    citySelected (val) {
      if (val instanceof Array) {
        this.projectModel.cityId = val[val.length - 1]
      } else {
        this.projectModel.cityId = val
      }
    },
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          this.projectModel.cost = Math.round(this.projectModel.cost * 100)
          await Api.Project.addProject(this.projectModel)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('新增成功!')
              this.projectModel= {
                name: null,
                type: null,
                filingNo: null,
                planLicenseNo: null,
                constrLicenceNo: null,
                landLicenceNo: null,
                cityCode: null,
                cityId: null,
                area: null,
                cost: null,
                site: null,
                startdate: null,
                finishdate: null,
                duration: null,
                qualityRequirement: null
              }
              this.loading = false
              this.$Spin.hide()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    },
    async initPrjTypes () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        this.$Api.Project.getPrjTypes().then(res => {
          this.prjTypes = res
          this.$Spin.hide()
          resolve(res)
        }).catch(err => {
          this.$Message.error(err.message)
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    prepPrjTypeCascader (list) {
      let data = []
      let topTier = list.filter(o => {
        return o.parentNode === null
        })
      topTier.forEach((t1) => {
        let tierId = t1.tid
        if (!t1.children) {
          t1.children = []
        }
        let secondTier = list.filter(o => {
          return o.parentNode === tierId
        })
        secondTier.forEach((t2) => {
          t1.children.push({
            label: t2.prjType,
            value: t2.tid,
            tid: t2.tid
          })
        })
        data.push({
          label: t1.prjType,
          value: t1.tid,
          tid: t1.tid,
          children: t1.children
        })
      })
      return data
    },
    prjTypeSelected (val) {
      if (val instanceof Array) {
        this.projectModel.type = val[val.length - 1]
      } else {
        this.projectModel.type = val
      }
    }
  }
}
</script>

<style lang="less">
</style>
